import React, { useEffect, useState } from "react";
import PieChart, {
  Series,
  Legend,
  Label,
  Connector,
  Size,
  Border,
} from "devextreme-react/pie-chart";
import CenterTemplate from "./CenterTemplate.js";
import { Chart } from "devextreme-react";

const customizeLabel = (e) =>
  `<p class="text-[16px] font-[Red Hat Display, sans-serif]">${e.valueText}%</p>\n<p class="text-[10px] monitor-graph-label-text">${e.argumentText}</p>`;
// const customizeLabel = (e) => {
//   <div>
//     <p className="text-[17px]">${e.valueText}%</p>
//     <p className="text-[#B19EA0] text-[12px]">{e.argumentText}</p>
//   </div>;
// };

function CustomLabelCenter({ colorGradingRatio }) {
  const [colorGradingData, setColorGradingData] = useState(null);

  useEffect(() => {
    setColorGradingData([
      {
        percentage: colorGradingRatio?.noChange?.percentage,
        category: "No Change",
        color: "#FEDF89", // Yellow for No-Change
      },
      {
        percentage: colorGradingRatio?.upgraded?.percentage,
        category: "Upgrade",
        color: "#32D583", // Green for Upgraded
      },
      {
        percentage: colorGradingRatio?.downgraded?.percentage,
        category: "Downgrade",
        color: "#F97066", // Red for Downgraded
      },
    ]);
  }, [colorGradingRatio]);

  return (
    <div className="flex justify-center items-center p-2 max-w-[100%] custom-graphs custom-bar-chart">
      {colorGradingData && (
        <Chart
          id="bar-chart"
          dataSource={colorGradingData}
          className="max-h-64 max-w-[100%]"
          // resolveLabelOverlapping="shift"
          // sizeGroup="piesGroup"
          // innerRadius={0.65}
          // centerRender={CenterTemplate}
          customizePoint={(pointInfo) => ({
          color: pointInfo.data.color,
        })}
        >
          <Series
            argumentField="category"
            valueField="percentage"
            type="bar"

            // Use small offsets to simulate gaps
          >
            {/* <Border
              visible={true}
              width={10}
              color="#EEEEEE"
              cornerRadius={10}
            /> */}
            {/* Simulate gaps */}
            <Label
              visible={true}
              format="fixedPoint"
              customizeText={customizeLabel}
              radialOffset={-50}
              backgroundColor="white"
              font={{ color: "black", weight: 600 }}
            >
              <Connector visible={true} />
              <Border visible={true} radius={10} />
            </Label>
          </Series>
          <Legend visible={false} />
          {/* <Size width={500} /> */}
        </Chart>
      )}
    </div>
  );
}

export default CustomLabelCenter;
